import ZalesFooter from "./zales"
import React from "react";

class PagodaFooter extends ZalesFooter {
    siteDomain = 'PAGODA.COM'
    getShopOutlet(){
        return (
               <div></div>
        )
    }
    getSocialIconsDiv() {
        return (
            <div style={this.styleHidden} className="social" >
                <span style={{border: '1px solid #808080', height: '41px', marginLeft:'8px', zIndex: '1000'}}>
                    <a href="https://www.facebook.com/Pagoda">
                        <img
                            alt="View Pagoda on Facebook"
                            src="/img/social_icons/facebook.png"
                            style={{display: 'inline'}}/>
                    </a>
                </span>
                <span style={{border: '1px solid #808080', height: '41px', marginLeft:'10px', zIndex: '1000' }}>
                    <a href="https://twitter.com/piercingpagoda">
                        <img
                            alt="View Piercing Pagoda on Twitter" src="/img/social_icons/twitter.png"
                            style={{display: 'inline'}}/>
                    </a>
                </span>
                <span style={{border: '1px solid #808080', height: '41px', marginLeft:'-96px', marginTop: '50px', zIndex: '1000', }}>
                    <a href="https://www.pinterest.com/piercingpagoda/">
                        <img
                            alt="View Piercing Pagoda on Pinterest"
                            src="/img/social_icons/pinterest.png"
                            style={{display: 'inline'}}/>
                    </a>
                </span>
                <span style={{border: '1px solid #808080', height: '41px', marginLeft:'10px', marginTop: '50px', zIndex: '1000'}}>
                   <a href="https://www.instagram.com/piercingpagoda/">
                        <img
                            alt="View Piercing Pagoda on Instagram" src="/img/social_icons/insta.png"
                            style={{display: 'inline'}}/>
                    </a>
                </span>
            </div>
          
        )
    }
    getSocialIcons() {
        return (
            <ul style={this.styleHidden} className="social no-padding">
                <li>
                    <a href="https://www.facebook.com/Pagoda">
                        <img
                            alt="View Pagoda on Facebook"
                            src="/img/social_icons/facebook.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://twitter.com/piercingpagoda">
                        <img
                            alt="View Piercing Pagoda on Twitter" src="/img/social_icons/twitter.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://www.pinterest.com/piercingpagoda/">
                        <img
                            alt="View Piercing Pagoda on Pinterest"
                            src="/img/social_icons/pinterest.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/piercingpagoda/">
                        <img
                            alt="View Piercing Pagoda on Instagram" src="/img/social_icons/insta.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
            </ul>
        )
    }
}

export default PagodaFooter



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/pagoda.js